import React, { useState, useEffect, useRef, useLayoutEffect } from "react";
import Screen from "../shared/screen";
import "./style.css";
import { axiosInstance } from "../../config/apiTemplate";
import Skeleton from "@mui/material/Skeleton";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { stripCommaToNum } from "../shared/util";
import InfoIcon from '@mui/icons-material/Info';
import Tooltip from '@mui/material/Tooltip';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import HelpOutlineOutlinedIcon from '@mui/icons-material/HelpOutlineOutlined';
import IconButton from '@mui/material/IconButton';
import { EtTable } from "../shared/table/table";
import { DataGridPro,GridToolbarContainer,GridToolbarColumnsButton,GridToolbarFilterButton,GridToolbarExport,GridToolbarDensitySelector, GridOverlay } from "@mui/x-data-grid-pro";
import LinearProgress  from "@mui/material/LinearProgress";

am4core.useTheme(am4themes_animated);

function SavingsPage() {
  const cashRatioChart = useRef(null);
  const navChart = useRef(null);
  const [toggles, setToggle] = useState([
    false,
    false,
    false,
    false,
    false,
    false,
  ]);
  const [isLoading, setLoading] = useState(true);
  const [portfolio, setPortfolio] = useState(localStorage.getItem("t_id"));
  const [dashboard, setDashboard] = useState({
    top_shareholdings: [],
    latest_trades: [],
    latest_dividends: [],
    chart_data: [],
    portfolio_cash_ratio: { cash: 10, stocks: 100 },
    daily_change: {
      klci_change_perc: 0,
      portfolio_change: 0,
      portfolio_change_perc: 0,
      today_value: 0,
      yesterday_value: 0,
    },
  });
  const [aggregatedData, setAggregatedData] = useState({
    initialTpv:0,
    currentTpv:0,
    abs_return:0,
    abs_return_percentage:0,
    aggregatedTPV:[],
    unconfirmed_deposit:0
  });
  const [deposits, setDeposits] = useState("0");
  const [cashBalance, setCashBalance] = useState("0");
  const [mmInterest, setMmInterest] = useState("0");
  const [floatingBalance, setFloatingBalance] = useState("0");
  const [mmInterestLogs, setMmInterestLogs] = useState([]);
  const [strategies, setStrategies] = useState([]);
  const [status, setStatus] = useState({
    boi_summary: []
  });
  let [tabIndex, setTabIndex] = useState(0);
  let productView = localStorage.getItem("productView");
  let client_code = localStorage.getItem("clientCode");

  useEffect(() => {
    document.title = "ETSW - Portfolio Dashboard";

    // Sleep 1 second
    setTimeout(() => {
      // getDashboardData();
      // getAggregatedData();
      // getStatus();
      getStats();
    }, 1000);

    // getDashboardData();
    // getAggregatedData();
  }, []);

  //  API ========================================================================================================================

  async function getStats(){
    const url = "client_api/savings/getStats_v2.php";

    let statsForm = new FormData();
    statsForm.append("client_code", client_code);

    try {
      const response = await axiosInstance.post(url, statsForm);
      if(response.data.status === 201){
        setDeposits(response.data.deposits);
        setCashBalance(response.data.cash_balance);
        setMmInterest(response.data.mm_interest);
        setMmInterestLogs(response.data.mm_interest_logs);
        setStrategies(response.data.strategies);
        setFloatingBalance(response.data.pending_approval);
      }
    } catch (e) {
      console.log(e);
    }
  }

  //  FUNCTIONS ========================================================================================================================

  function getTotalShareholdings() {
    if (dashboard.top_shareholdings.length > 0)
      return dashboard.top_shareholdings
        .reduce((a, b) => a + Number(b.portfolio_percent), 0)
        .toFixed(2);

    return 0;
  }

  // RENDER FUNCTIONS  ========================================================================================================================\

  function prepareTableRows(){
    return mmInterestLogs.map((item,index)=>{
      return {...item,no:(index+1),id:index};
    });
  }

  function loadingOverlay(){
    return(
        <GridOverlay>
            <div style={{ position: 'absolute', top: 0, width: '100%' }}>
            <LinearProgress />
            </div>
        </GridOverlay>
    )
  }

  function renderNoRows(){
    return(
        <GridOverlay>
            <div>
                <h6 style={{fontStyle:"italic"}}>No Transactions....</h6>
            </div>
        </GridOverlay>
    )
  }

  function renderNoRows2(){
    return(
        <GridOverlay>
            <div>
                <h6 style={{fontStyle:"italic"}}>No Strategies....</h6>
            </div>
        </GridOverlay>
    )
  }

  function changePortfolio(t_id) {
    setPortfolio(t_id);
  }

  function invokeRefresh() {
    setLoading(true);
  }

  function renderDATUpdateTooltip(){
    return(
      <Tooltip title="Updated hourly">
        <ErrorOutlineIcon style={{cursor:'pointer',fontSize:27}}/>
      </Tooltip>
    )
  }

  return (
    <div>
      <Screen
        origin='dashboard'
        setPortfolio={changePortfolio}
        invokeRefresh={invokeRefresh}
      >
        <div style={{textAlign:'center',fontSize:30}}>
          ET SavingsTracker
        </div>
        <br />
        <div className="row justify-content-center px-3">
            {/* <div className="col-lg-6 col-md-6 col-sm-12 mb-3">
                <div className="aggStatBox">
                    <h3 className="boldText mb-3">Deposits</h3>
                    <h4 className="boldText text-center">RM {deposits}</h4>
                </div>
            </div> */}
            <div className="col-lg-4 col-md-4 col-sm-12 mb-4">
                <div className="aggStatBox">
                    <h3 className="boldText mb-3">
                      Net Profit Earned&nbsp;
                      <Tooltip title={
                        <div>
                          Net Profit Earned = Total Profit Earned - (Accrued Management Fees + Accrued Custodian Fees + Bank Charges)
                          <br /><br />
                          You may experience a temporary drop in the Net Profit Earned figure between 11:30 pm to 11:00 am the following day due to daily accruals and profit earned calculations.
                          <br /><br />
                          Daily accruals calculated - 11:30 pm daily.
                          <br /><br />
                          Daily profit earned calculated - 11:00 am daily.
                        </div>
                      }>
                        <ErrorOutlineIcon style={{cursor:'pointer',fontSize:27}}/>
                      </Tooltip>
                    </h3>
                    <h4 className="boldText text-center" style={{ color: mmInterest >= 0 ? "green" : "red" }}>RM {mmInterest}</h4>
                </div>
            </div>
            <div className="col-lg-4 col-md-4 col-sm-12 mb-4">
                <div className="aggStatBox">
                    <h3 className="boldText mb-3">
                      Net Cash Balance&nbsp;
                      <Tooltip title={
                        <div>
                          Net Cash Balance = Total Cash Balance + Total Profit Earned - (Accrued Management Fees + Accrued Custodian Fees + Bank Charges)
                          <br /><br />
                          You may experience a temporary drop in the Net Cash Balance figure between 11:30 pm to 11:00 am the following day due to daily accruals and profit earned calculations.
                          <br /><br />
                          Daily accruals calculated - 11:30 pm daily.
                          <br /><br />
                          Daily profit earned calculated - 11:00 am daily.
                        </div>
                      }>
                        <ErrorOutlineIcon style={{cursor:'pointer',fontSize:27}}/>
                      </Tooltip>
                    </h3>
                    <h4 className="boldText text-center">RM {cashBalance}</h4>
                </div>
            </div>
            <div className="col-lg-4 col-md-4 col-sm-12 mb-4">
                <div className="aggStatBox">
                    <h3 className="boldText mb-3">
                      Floating Balance&nbsp;
                      <Tooltip title="Floating balance = Funds received but not yet approved. Approvals are processed Monday to Thursday 9:00 am - 5:00 pm.">
                        <ErrorOutlineIcon style={{cursor:'pointer',fontSize:27}}/>
                      </Tooltip>
                    </h3>
                    <h4 className="boldText text-center">RM {floatingBalance}</h4>
                </div>
            </div>
            {/* <div className="col-lg-6 col-md-6 col-sm-12 mb-3">
                <div className="aggStatBox">
                    <h3 className="boldText mb-3">Withdrawals</h3>
                    <h4 className="boldText text-center">RM 0.00</h4>
                </div>
            </div> */}

            <div className="col-lg-6 col-md-6 col-sm-12 mb-3">
              <div className="aggStatBox">
                <h3 className="boldText mb-3">Gross Profit Logs</h3>
                {/* <table>
                  <thead>
                    <tr>
                      <th>Date</th>
                      <th>Amount</th>
                      <th>Interest</th>
                      <th>Description</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>2025-01-01</td>
                      <td>RM 100,000.00</td>
                      <td>RM 0.5</td>
                      <td>Interest</td>
                    </tr>
                    <tr>
                      <td>2025-01-02</td>
                      <td>RM 200.00</td>
                      <td>RM 10.00</td>
                      <td>Interest</td>
                    </tr>
                  </tbody>
                </table> */}

                <div style={{ flexGrow: 1, backgroundColor: "white", marginTop: 20, height: 300 }}>
                  <DataGridPro
                    density="compact"
                    // loading={isLoading}
                    columns={[
                        {
                            field: "reg_date",
                            headerName: "Date",
                            width: 150,
                            align: 'center',
                            headerAlign: 'center',
                            // flex: 1,
                        },
                        {
                            field: "amount",
                            headerName: "Amount",
                            // minWidth: 50,
                            flex: 1,
                            align: 'center',
                            headerAlign: 'center',
                        }
                    ]}
                    pagination
                    rows={prepareTableRows()}
                    components={{
                        // Toolbar: renderCustomToolbar,
                        LoadingOverlay: loadingOverlay,
                        NoRowsOverlay: renderNoRows
                    }}  
                  />
                </div>
              </div>
            </div>
            <div className="col-lg-6 col-md-6 col-sm-12 mb-3">
              <div className="aggStatBox">
                <h3 className="boldText mb-3">Strategies</h3>
                {/* <table>
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Strategy Name</th>
                      <th>Client Code</th>
                      <th>Starting Amount</th>
                      <th>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>1</td>
                      <td>Snowball</td>
                      <td>SW-A1-2510-10281-1</td>
                      <td>RM 50,000.00</td>
                      <td>Started</td>
                    </tr>
                    <tr>
                      <td>2</td>
                      <td>Digital Assets Tracker</td>
                      <td>N/A</td>
                      <td>RM 100,000.00</td>
                      <td>Pending</td>
                    </tr>
                  </tbody>
                </table> */}

                <div style={{ flexGrow: 1, backgroundColor: "white", marginTop: 20, height: 300 }}>
                  <DataGridPro
                    density="compact"
                    // loading={isLoading}
                    columns={[
                        {
                            field: "strategy_label",
                            headerName: "Strategy Name",
                            flex: 1,
                            align: 'center',
                            headerAlign: 'center',
                        },
                        {
                            field: "strategy_client_code",
                            headerName: "Client Code",
                            minWidth: 50,
                            flex: 1,
                            align: 'center',
                            headerAlign: 'center',
                        },
                        {
                          field: "amount",
                          headerName: "Starting Amount",
                          minWidth: 50,
                          flex: 1,
                          align: 'center',
                          headerAlign: 'center',
                        },
                        {
                          field: "strategy_distributed",
                          headerName: "Status",
                          minWidth: 50,
                          flex: 1,
                          align: 'center',
                          headerAlign: 'center',
                        },
                    ]}
                    pagination
                    rows={strategies}
                    components={{
                        // Toolbar: renderCustomToolbar,
                        LoadingOverlay: loadingOverlay,
                        NoRowsOverlay: renderNoRows2
                    }}  
                  />
                </div>

              </div>
            </div>
        </div>
      </Screen>
    </div>
  );
}

export default SavingsPage;
